export const teamLoading =  ({store})  => store.teamReducer.loading;

export const teamError =  ({store})  => store.teamReducer.error;

export const teamData =  ({store})  => store.teamReducer.data;